const messages = {
  title: "Cenníky a produktové brožúry",
  title_media: "Cenníky a produktové brožúry",
  description:
    "Stiahnite si najnovšie brožúry a letáky o našich pneumatikách Bridgestone a Firestone pre osobné autá, SUV a ľahké úžitkové vozidlá.",
  short_description:
    "Tu nájdete materiály pre sociálne siete, in-store TV a ďalšie.",
  mediaCategories: {
    products: "Produkty",
    brand_and_solutions: "Značka a riešenia",
    season_and_promotions: "Sezóna a akcie",
    format: "Formát",
    cars_and_vans: "Osobné auto, SUV, úžitkové",
    truck_and_buses: "Nákladné auto a autobus",
    motorcycle: "Motocykel",
    agriculture: "Poľnohospodárstvo",
    construction_machinery: "Stavebné stroje",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiály",
    brochures: "Produktové brožúry",
    price_list: "Cenníky",
    materials: "Materiály",
    video_in_store: "Video s titulkami",
    video_online: "Video bez titulkov",
    video: "Video",
    banner_website: "Banner",
    banner_social_media: "Sociálne siete",
    logos: "Logá",
    summer: "Leto",
    winter: "Zima",
    all_season: "Všetky sezóny",
    promotions: "Akcie",
    price: "Pricat",
  },
  mediasPage: {
    title: "MEDIATÉKA",
    description:
      "Vitajte v sekcii médií venovanej   \n" +
      "produktom Bridgestone a Firestone.  \n <br> <br>" +
      "Objavíte vizuály produktov,   \n" +
      "logotypy a tiež široký výber   \n" +
      "bannerov, videí a digitálnych materiálov   \n" +
      "na použitie na vašich webových stránkach alebo na   \n" +
      "sociálnych sieťach.  ",
    bDrive: {
      title: "Fotografie produktov",
      description:
        "Aktuálne obrázky   \n" +
        "možno stiahnuť   \n" +
        "z nášho portálu B-\n" +
        "DRIVE.  ",
    },
  },
  buttons: {
    media: "OBJAVIŤ",
  },
  searchMedia: "Zadajte kľúčové slovo",
  searchResults: "Výsledky vyhľadávania",
};

export default {
  messages,
};
